// @ts-expect-error Untyped module
import ExtensionInstallHelpers from 'ExtensionInstallHelpers/SidekickExtensionInstallHelpers';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const ProductSetupUIBranch = {
  name: 'ProductSetupUIBranch',
  // FIXME: add correct state check
  // stateCheck: (state: RootAppState) => getShowProductSetupUIBranch(state),
  stateCheck: () => false,
  rebuildFlow: (flow, state, dispatch) => {
    const hasSalesExtension = ExtensionInstallHelpers.hasExtension();
    const postAccountCreationSteps = [...getFlowSteps().postAccountCreation];
    const flowSteps = [...flow];

    if (!hasSalesExtension) {
      flowSteps.push(Step.InstallSalesExtension);
      postAccountCreationSteps.push(Step.InstallSalesExtension);
    } else {
      flowSteps.push(Step.TrackEmail, Step.TrackEmailConfirmation);
      postAccountCreationSteps.push(Step.TrackEmail, Step.TrackEmailConfirmation);
    }

    dispatch(setFlow(flowSteps, getFlowSteps().preVerification, getFlowSteps().postVerification, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection));
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};